import { render, staticRenderFns } from "./PosReceivableBankImport.vue?vue&type=template&id=7f28cdf5"
import script from "./PosReceivableBankImport.vue?vue&type=script&lang=js"
export * from "./PosReceivableBankImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports